import featureFlags from "../../../feature-flags.json";

export const FEATURE_FLAGS = featureFlags;
